// extracted by mini-css-extract-plugin
export default {"button":"Button_button__8H-GG","lightButton":"Button_lightButton__mLWQP","smallButton":"Button_smallButton__+WRwR"};